import { render, staticRenderFns } from "./BuddhismOrder.vue?vue&type=template&id=797e0452&scoped=true"
import script from "./BuddhismOrder.vue?vue&type=script&lang=js"
export * from "./BuddhismOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e0452",
  null
  
)

export default component.exports